import React, { useState } from "react"
import logoImg from "../assets/images/logoWhite.png"
import logoImgSm from "../assets/images/logoSquareWhite.png"
import { useNavigate } from "react-router-dom"
import { useAuth } from '../context/authContext'
import { useLocation } from "react-router-dom"

const Sidebar = () => {
    const navigate = useNavigate()
    const { logout, role } = useAuth()
    const location = useLocation()
    const [isLeadsOpen, setIsLeadsOpen] = useState(false)
    const [isAdsOpen, setIsAdsOpen] = useState(false)

    const getClassName = (path) => {
        return location.pathname === path ? 'side-nav-link toggle active' : 'side-nav-link toggle'
    }

    const toggleLeadsDropdown = () => {
        setIsLeadsOpen(!isLeadsOpen)
    }

    const toggleAdsDropdown = () => {
        setIsAdsOpen(!isAdsOpen)
    }

    return (
        <div className="leftside-menu">
            <a href="index.html" className="logo logo-light">
                <span className="logo-lg">
                    <img src={logoImg} alt="logo" />
                </span>
                <span className="logo-sm">
                    <img src={logoImgSm} alt="small logo" />
                </span>
            </a>

            <a href="index.html" className="logo logo-dark">
                <span className="logo-lg">
                    <img src={logoImg} alt="dark logo" />
                </span>
                <span className="logo-sm">
                    <img src={logoImgSm} alt="small logo" />
                </span>
            </a>

            <div className="h-100" id="leftside-menu-container" data-simplebar>

                <ul className="side-nav">
                    <li className="side-nav-title">Main</li>
                    <li className="side-nav-item">
                        <div onClick={() => { navigate("/dashboard") }}
                            className={getClassName('/dashboard')}>
                            <i className="ri-dashboard-3-line"></i>
                            <span> Dashboard </span>
                        </div>
                    </li>
                    <li className={`side-nav-item ${isLeadsOpen ? 'mm-show' : ''}`}>
                        <div
                            onClick={toggleLeadsDropdown}
                            className="side-nav-link"
                        >
                            <i className="ri-user-2-line"></i>
                            <span> Leads </span>
                            <span className="float-end">
                                {isLeadsOpen ? <i className="ri-arrow-up-s-line"></i> : <i className="ri-arrow-down-s-line"></i>}
                            </span>
                        </div>

                        {isLeadsOpen && (
                            <ul className="side-nav-second-level">
                                <li>
                                    <div
                                        onClick={() => navigate("/leads/chatbot")}
                                        className={getClassName('/leads/chatbot')}
                                    >
                                        Chatbot Leads
                                    </div>
                                </li>
                                <li>
                                    <div
                                        onClick={() => navigate("/leads/contact")}
                                        className={getClassName('/leads/contact')}
                                    >
                                        Contact Leads
                                    </div>
                                </li>
                                <li>
                                    <div
                                        onClick={() => navigate("/leads/mortgage")}
                                        className={getClassName('/leads/mortgage')}
                                    >
                                        Mortgage Leads
                                    </div>
                                </li>
                            </ul>
                        )}
                    </li>
                    <li className="side-nav-item">
                        <div onClick={() => { navigate("/properties") }}
                            className={getClassName('/properties')}>
                            <i className="ri-building-line"></i>
                            <span> Properties </span>
                        </div>
                    </li>
                    <li className={`side-nav-item ${isAdsOpen ? 'mm-show' : ''}`}>
                        <div
                            onClick={toggleAdsDropdown}
                            className="side-nav-link"
                        >
                            <i className="ri-user-2-line"></i>
                            <span> Ads Management </span>
                            <span className="float-end">
                                {isAdsOpen ? <i className="ri-arrow-up-s-line"></i> : <i className="ri-arrow-down-s-line"></i>}
                            </span>
                        </div>
                        {isAdsOpen && (
                            <ul className="side-nav-second-level">
                                <li>
                                    <div
                                        onClick={() => navigate("/ads/hero")}
                                        className={getClassName('/ads/hero')}
                                    >
                                        Hero Ads Management
                                    </div>
                                </li>
                                <li>
                                    <div
                                        onClick={() => navigate("/ads/seo")}
                                        className={getClassName('/ads/seo')}
                                    >
                                        SEO Ads Management
                                    </div>
                                </li>
                            </ul>
                        )}
                    </li>
                    {
                        role != 3 &&
                        <li className="side-nav-item">
                            <div onClick={() => { navigate("/user-management") }}
                                className={getClassName('/user-management')}>
                                <i class="bi bi-person-lines-fill"></i>
                                <span> User Management </span>
                            </div>
                        </li>
                    }
                    {
                        role != 3 &&
                        <li className="side-nav-item">
                            <div onClick={() => { navigate("/team-members") }}
                                className={getClassName('/team-members')}>
                                <i class="bi bi-person-badge"></i>
                                <span> Team Members </span>
                            </div>
                        </li>
                    }
                    {/* <li className="side-nav-item">
                        <div onClick={() => {navigate("/products")}}
                            className={getClassName('/products')}>
                            <i className="ri-user-3-line"></i>
                            <span> Products </span>
                        </div>
                    </li>
                    <li className="side-nav-item">
                        <div onClick={() => {navigate("/eibor")}}
                            className={getClassName('/eibor')}>
                            <i className="ri-user-4-line"></i>
                            <span> EIBOR </span>
                        </div>
                    </li> */}

                    <li className="side-nav-title">Settings</li>
                    {/* <li className="side-nav-item">
                        <div onClick={() => {navigate('/profile')}}
                            className={getClassName('/profile')}>
                            <i className="ri-profile-fill"></i>
                            <span> Profile </span>
                        </div>
                    </li> */}
                    <li className="side-nav-item">
                        <div onClick={() => { logout(); navigate('/login') }}
                            className='side-nav-link toggle'>
                            <i className="ri-logout-box-line"></i>
                            <span> Logout </span>
                        </div>
                    </li>
                </ul>

                <div className="clearfix"></div>
            </div>
        </div>
    )
}

export default Sidebar